import angular from 'angular';
import constants from 'app/constants';
import activeAudit from './activeAudit';
import completedAudit from './completedAudit';
import directive from './audits.directive';

export { default as auditUniqueNameValidator } from './messages/audit-unique-name.validator.directive';

export default angular.module('app.components.advisory.auditTrail.audits', [
  activeAudit,
  completedAudit,
  constants,
])
  .directive('amAudits', directive)
  .name;

console.log('app.components.advisory.auditTrail.audits created');
